import { useAuth } from "src/components/providers/auth-context";

const useTeamAction = (action, demoAction) => {
    const { userHasTeamsSubscription } = useAuth();
    if (userHasTeamsSubscription) {
        return action;
    }
    return demoAction;
};

export default useTeamAction;
